import TableCellArrayInput from "./Container";

export default TableCellArrayInput;
